import { initializeApp } from 'firebase/app'
import 'firebase/remote-config'

const firebaseConfig = {
  apiKey: 'AIzaSyCLqghBR0ApepkRgsyD1aSoaGwiolOVNNs',
  authDomain: 'quickmd-c76a8.firebaseapp.com',
  projectId: 'quickmd-c76a8',
  storageBucket: 'quickmd-c76a8.appspot.com',
  messagingSenderId: '663932840781',
  appId: '1:663932840781:web:14740c21e51a005c8c2504',
}

export const firebase = initializeApp(firebaseConfig)
